import React, { ChangeEvent, FC } from 'react'
import { Tab, Tabs } from '@material-ui/core'
import { useQueryProjectTags } from './tags.utils'
import { useProjectTagsStyles } from './project-tags.style'
import { useProjectsFilters } from '../common'
import { components } from '@plandi/common/src/generated'

export const ProjectTags: FC = () => {
  const { data: tags } = useQueryProjectTags()
  const { tag: activeTag, setProjectsFilters } = useProjectsFilters()
  const classes = useProjectTagsStyles()

  const handleTagChange = (
    event: ChangeEvent<Record<string, never>>,
    newVal: number
  ) => {
    event.preventDefault()
    if (newVal === activeTag) {
      setProjectsFilters({
        tag: undefined,
        page: 1,
        categoryIds: undefined,
        subCategoryIds: undefined
      })
      return
    }
    const tag = tags?.find(
      (tag) => tag.id == newVal
    ) as components['schemas']['ProjectTagResource']
    setProjectsFilters({
      tag: newVal,
      page: 1,
      categoryIds: Array.isArray(tag?.category)
        ? tag?.category
        : [tag?.category],
      subCategoryIds: (Array.isArray(tag?.subcategory)
        ? tag?.subcategory
        : [tag?.subcategory]) as number[]
    })
  }

  return (
    <Tabs
      orientation={'horizontal'}
      scrollButtons={'on'}
      variant={'scrollable'}
      onChange={handleTagChange}
      value={activeTag}
      textColor={'secondary'}
      classes={{ root: classes.root, indicator: classes.indicator }}
    >
      {tags?.map((tag) => (
        <Tab
          label={tag.title}
          key={tag.id}
          value={tag.id}
          disableRipple
          classes={{
            wrapper:
              tag.id === activeTag
                ? classes.tabWrapperActive
                : classes.tabWrapper
          }}
        />
      ))}
    </Tabs>
  )
}
